module.exports = __webpack_public_path__ + "static/media/google-play-badge.240b212b.png";